export default `
-- CreateTable
CREATE TABLE "ProfilePublicTrack" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "user_id" TEXT NOT NULL,
    "file_id" TEXT NOT NULL,
    "file_revision_id" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    CONSTRAINT "ProfilePublicTrack_file_id_fkey" FOREIGN KEY ("file_id") REFERENCES "File" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "ProfilePublicTrack_file_revision_id_fkey" FOREIGN KEY ("file_revision_id") REFERENCES "FileRevision" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "ProfilePublicTrack_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateIndex
CREATE INDEX "ProfilePublicTrack_user_id_idx" ON "ProfilePublicTrack"("user_id");

-- CreateIndex
CREATE INDEX "ProfilePublicTrack_file_id_idx" ON "ProfilePublicTrack"("file_id");

-- CreateIndex
CREATE INDEX "ProfilePublicTrack_file_revision_id_idx" ON "ProfilePublicTrack"("file_revision_id");

-- CreateIndex
CREATE INDEX "ProfilePublicTrack_workspace_id_idx" ON "ProfilePublicTrack"("workspace_id");

-- CreateIndex
CREATE INDEX "ProfilePublicTrack_created_by_idx" ON "ProfilePublicTrack"("created_by");

-- CreateIndex
CREATE INDEX "ProfilePublicTrack_created_at_idx" ON "ProfilePublicTrack"("created_at");

-- CreateIndex
CREATE UNIQUE INDEX "ProfilePublicTrack_user_id_file_id_key" ON "ProfilePublicTrack"("user_id", "file_id");
`;
